import React, { useEffect } from 'react';
import { VertTypography, VertModal, Skeleton } from '@vertem-core/vertice-ds';
import { useDispatch, useSelector } from 'react-redux';

import { loadSpotTracking, resetSpotTracking } from 'redux/Reducers/Spot/spotGroupsSlice';
import { SpotContainerModal } from './components/SpotContainerModal';
import 'Assets/styles/default/components/Orders/OrderDetails/OrderDetailsStyles.less';

const SpotModalTracking = (props) => {
  const dispatch = useDispatch();

  const { isOpen, onClose, productId } = props;
  const { spotDataTracking, errorSpotDataTracking, loadingDataTracking } = useSelector(
    (state) => state.SpotGroups,
  );

  useEffect(() => {
    if (productId) {
      dispatch(
        loadSpotTracking({
          redemptionId: productId,
        }),
      );
    }
  }, [productId]);

  useEffect(() => {
    return () => {
      dispatch(resetSpotTracking());
    };
  }, []);

  return (
    <VertModal
      open={isOpen}
      onCancel={() => {
        onClose();
      }}
      wrapClassName='modal-spot-tracking-wrapper'
      footer={null}
      
      destroyOnClose
    >
      <Skeleton active loading={loadingDataTracking} paragraph={{ rows: 8 }}>
        {errorSpotDataTracking && !spotDataTracking && (
          <div className='container-modal-spot-tracking'>
            <VertTypography.Title level={3} className='modal-title-spot-tracking' strong>
              Rastreio não disponível
            </VertTypography.Title>
            <VertTypography.Paragraph>
              O rastreio não foi encontrado ou não está disponível no momento.
            </VertTypography.Paragraph>
          </div>
        )}

        {spotDataTracking && <SpotContainerModal {...props} />}
      </Skeleton>
    </VertModal>
  );
};

export default SpotModalTracking;
